import { httpResource } from '@angular/common/http';
import { Injector, signal } from '@angular/core';
import { injectApiUrl } from '@seatix/shared-config';
import { ApiResponse, User } from '@seatix/shared/domain';
import { assertInjector } from 'ngxtension/assert-injector';
import { createInjectionToken } from 'ngxtension/create-injection-token';

export const [injectUserApiUrl, provideUserApiUrl] = createInjectionToken(
  () => {
    return injectApiUrl() + '/api/auth/me';
  },
);

export const [injectIsUserResourceActive, provideIsUserResourceActive] =
  createInjectionToken(() => {
    return signal(false);
  });

export function injectUserResource(injector?: Injector) {
  return assertInjector(injectUserResource, injector, () => {
    const apiUrl = injectUserApiUrl();
    const isActive = injectIsUserResourceActive();
    return httpResource(() => (isActive() ? apiUrl : undefined), {
      parse: (response) => (response as ApiResponse<User>).data,
    });
  });
}
